import './App.css';
import ChessBoard from './componets/ChessBoard';

function App() {
  return (
    <div className="App">
      <ChessBoard/>
    </div>
  );
}

export default App;
